/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AppSchemasArbitratorCriterionInput } from './appSchemasArbitratorCriterionInput';
import type { CreatePresetRequestVisibility } from './createPresetRequestVisibility';

export interface CreatePresetRequest {
  /**
     * @minLength 1
     * @maxLength 120
     */
  name: string;
  /** @maxLength 1000 */
  description?: string;
  visibility?: CreatePresetRequestVisibility;
  /**
     * @minItems 1
     * @maxItems 20
     */
  criteria: AppSchemasArbitratorCriterionInput[];
}
